import { render } from "./ResumeModalGuestExpert.vue?vue&type=template&id=56d9d82a"
import script from "./ResumeModalGuestExpert.vue?vue&type=script&lang=js"
export * from "./ResumeModalGuestExpert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__